<template>
  <div class="homebot">
    <!-- <div class="top">
      <div class="top-left">
        <ul>
          <li v-for="(item, index) in routerList"  :key="index">
            <span @click="fun(item.url)">{{ item.name }}</span>
          </li>
          <div class="top-right" @click="goCase()" style="cursor:pointer">
            <span>赣ICP备2023002526号-1 </span>
          </div>
        </ul>
      </div>
      <div class="top-right">
        <img src="../assets/img/weixin_back.png">
        <img src="../assets/img/zhifubao_back.png">
      </div>
    </div> -->
    <div class="bg-mask"></div>
    <div class="footer-content">
      <button class="footer-brand" type="button" aria-label="返回首页" @click="fun('Index')">
        <img src="../assets/pizzaking/footer-pizzaking-cj-icon.png" alt="" />
        <strong>PizzaKing<span>-CJ</span></strong>
      </button>
      <p class="site-description">{{ siteContent.footer.description }}</p>
      <div class="platform-info">
        <div class="item">
          <span>{{ info.openbox_num }}</span>
          <span>已开启盲盒总数</span>
        </div>
        <div class="item center">
          <span>{{ info.player_num }}</span>
          <span>已注册人数</span>
        </div>
        <div class="item">
          <span>{{ info.online_num }}</span>
          <span>在线人数</span>
        </div>
      </div>
      <ul class="list">
        <li
          v-for="(item, index) in routerList"
          @click="fun(item.url)"
          :key="`${item.url}-${index}`"
        >
          <span class="link-name">{{ item.name }}</span>
          <span v-if="index + 1 != routerList.length">|</span>
        </li>
      </ul>
      <FooterFriendLinks class="footer-friend-links" />
      <div class="copyright">
        <span class="ba-right">{{ siteContent.footer.copyright }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneSiteContent, loadSiteContent } from "@/services/siteContent";
import FooterFriendLinks from "@/components/FooterFriendLinks.vue";

export default {
  components: { FooterFriendLinks },
  data() {
    return {
      routerList: [
        { name: "关于我们", url: "Abouts" },
        { name: "用户协议", url: "Agreement" },
        { name: "隐私条款", url: "Privacy" },
        { name: "协议与条款", url: "Clause" },
        { name: "常见问题", url: "Doubt" },
      ],
      urlList: [],
      siteContent: cloneSiteContent(),
      info: {
        player_num: 0,
        online_num: 0,
        openbox_num: 0,
      },
    };
  },
  created() {
    loadSiteContent(this.$axios).then((content) => {
      this.siteContent = content;
    });
    this.$axios
      .post("/index/Login/logininfo", this.$qs.stringify({}))
      .then((res) => {
        if (res.data.status) {
          this.info = res.data.data;
        }
      });
  },
  methods: {
    fun(url) {
      this.$router.push({
        path: `/${url}`,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.homebot {
  padding: 24px;
  height: 510px;
  position: relative;
  .bg-mask {
    background:
      radial-gradient(circle at 50% 0, rgba(255, 132, 31, 0.18), transparent 38%),
      linear-gradient(180deg, #1c1e2a, #15161f);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .copyright {
    max-width: 800px;
    margin: 20px auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .ba-right {
      color: #878787;
      font-size: 12px;
      cursor: pointer;
    }
    .top-right {
      margin-top: 20px;
    }
  }

  .footer-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background: transparent;
    color: #fff;
    .footer-brand {
      margin: 26px auto 0;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      color: #fff7dc;
      background: transparent;
      border: 0;
      cursor: pointer;
      img {
        width: 62px;
        height: 62px;
        flex: 0 0 62px;
        object-fit: contain;
      }
      strong {
        font-size: 24px;
        font-weight: 900;
        letter-spacing: -1px;
        line-height: 1;
        white-space: nowrap;
        span {
          color: #ff8a16;
        }
      }
    }
    .site-description {
      max-width: 760px;
      margin: 14px auto 0;
      padding: 0 18px;
      color: #8d95a7;
      font-size: 12px;
      font-weight: 700;
      line-height: 1.7;
      text-align: center;
    }
    .list {
      max-width: 800px;
      margin: 18px auto;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      img {
        cursor: pointer;
        margin-bottom: 10px;
      }
      li {
        margin-right: 10px;
        font-size: 12px;

        .link-name {
          margin-right: 10px;
          cursor: pointer;
        }
      }
    }
    .footer-friend-links {
      width: calc(100% - 48px);
      max-width: 1180px;
      margin: 0 auto;
    }
    .platform-info {
      max-width: 800px;
      margin: 40px auto;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        height: 100px;
        font-size: 14px;
        & > span:nth-child(1) {
          font-weight: bold;
          font-size: 16px;
        }
      }
      .center {
        position: relative;
        &::before {
          display: block;
          content: "";
          width: 1px;
          height: 100px;
          position: absolute;
          left: 0;
          top: 0;
          background-image: -webkit-gradient(
            linear,
            left top,
            left bottom,
            from(hsla(0, 0%, 100%, 0.1)),
            color-stop(#ccc),
            to(hsla(0, 0%, 100%, 0.1))
          );
          background-image: -webkit-linear-gradient(
            hsla(0, 0%, 100%, 0.1),
            #ccc,
            hsla(0, 0%, 100%, 0.1)
          );
          background-image: -o-linear-gradient(
            hsla(0, 0%, 100%, 0.1),
            #ccc,
            hsla(0, 0%, 100%, 0.1)
          );
          background-image: linear-gradient(
            hsla(0, 0%, 100%, 0.1),
            #ccc,
            hsla(0, 0%, 100%, 0.1)
          );
        }
        &::after {
          display: block;
          content: "";
          width: 1px;
          height: 100px;
          position: absolute;
          right: 0;
          top: 0;
          background-image: -webkit-gradient(
            linear,
            left top,
            left bottom,
            from(hsla(0, 0%, 100%, 0.1)),
            color-stop(#ccc),
            to(hsla(0, 0%, 100%, 0.1))
          );
          background-image: -webkit-linear-gradient(
            hsla(0, 0%, 100%, 0.1),
            #ccc,
            hsla(0, 0%, 100%, 0.1)
          );
          background-image: -o-linear-gradient(
            hsla(0, 0%, 100%, 0.1),
            #ccc,
            hsla(0, 0%, 100%, 0.1)
          );
          background-image: linear-gradient(
            hsla(0, 0%, 100%, 0.1),
            #ccc,
            hsla(0, 0%, 100%, 0.1)
          );
        }
      }
    }
  }

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #848492;
    .top-left {
      ul {
        display: flex;
        flex-wrap: wrap;

        li {
          margin-top: 10px;
          margin-right: 32px;
          span {
            white-space: nowrap;
            display: inline-block;
          }
        }
        li:hover {
          cursor: pointer;
        }
      }
    }
    .top-right {
      margin-top: 10px;

      img {
        margin-right: 10px;
      }
    }
  }
  .bot {
    margin-top: 24px;
    display: flex;
    font-size: 14px;
    color: #515260;
    overflow-y: hidden;
    .bot-title {
      margin-right: 12px;
    }
    ul {
      display: flex;
      li {
        margin-right: 24px;
      }
      li:hover {
        cursor: pointer;
        text-decoration: underline;
        color: #e9b10e;
      }
    }
  }
}

@media screen and (max-width: 560px) {
  .homebot {
    height: 690px;

    .footer-content {
      .platform-info {
        margin: 26px auto;
      }

      .footer-friend-links {
        width: calc(100% - 28px);
      }
    }
  }
}
</style>
